import { render, staticRenderFns } from "./QuantidadeAtendentes.vue?vue&type=template&id=6f423fba"
import script from "./QuantidadeAtendentes.vue?vue&type=script&lang=ts"
export * from "./QuantidadeAtendentes.vue?vue&type=script&lang=ts"
import style0 from "./QuantidadeAtendentes.vue?vue&type=style&index=0&id=6f423fba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports